export default "__VITE_PUBLIC_ASSET__98456310__"